import * as React from 'react';
import { Helmet } from 'react-helmet'
import {useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import rosey2 from '../pics/rosey2.png'
import ophelia from '../pics/Ophelia-New Photo-IMG_3280 (1).jpeg'
import fasihi from '../pics/fasihi.png'

const useStyles = makeStyles((theme) => ({
    body: {
        marginTop: '2vmin',
        height: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '5vh'
    },
    titleContainer: {
        [theme.breakpoints.down('md')]: {
            fontSize: '10vmin',
            paddingBottom: '7vmin',
            textShadow: 'black 0px 0 0px',
            WebkitTextStroke: '0px',
        },
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'oswald',
        color: '#5a2a20',
        fontSize: '8vmin',
        paddingBottom: '4vmin',
        WebkitTextStroke: '2px',
        WebkitTextStrokeColor: '#b68f72',
        textShadow: 'black 1px 0 5px'
    },
    title: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '7vmin',
            paddingBottom: '3vh',
            textShadow: 'black 0px 0 0px',
        },
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#b68f72',
        fontWeight: 'bold',
        fontFamily: 'oswald',
        fontSize: '5vmin',
        textShadow: 'black 1px 0 5px',
        marginBottom: '3%'

    },
    author: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '4vmin',
            paddingBottom: '1vh'
        },
        display: 'flex',
        alignItems: 'center',
        color: '#b68f72',
        fontFamily: 'arimo, sans serif',
        fontSize: '2.5vmin'
    },
    date:{
        [theme.breakpoints.down('sm')]: {
            fontSize: '4vmin',
            paddingBottom: '1vh'
        },
        
        display: 'flex',
        alignItems: 'center',
        color: '#b68f72',
        fontFamily: 'arimo, sans serif',
        fontSize: '2.5vmin',
        marginBottom: '1vh'
    },
    authorPic: {
        [theme.breakpoints.down('sm')]: {
            
        },
        height: 'auto',
        width: '20vmin',
        borderRadius: '50%',
        marginLeft: '5%'
    },
    blogHolder: {
        [theme.breakpoints.down('sm')]: {
            width: '90vw'
        },
        width: '50vw',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: '#5a2a20',
        boxShadow: '0 0 5px -1px rgba(0,0,0,0.6)',
        borderRadius: '10px',
        paddingLeft: '2vw',
        paddingRight:'2vw',
    },
    blog: {
        [theme.breakpoints.down('xs')]: {
           fontSize: '4vmin'
        },
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            fontSize: '4vmin'
        },
        fontSize: '2vmin',
        marginTop: '2vh',
        width: '100%',
        
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '1vh',
        color: 'white',
        fontSize: '2vmin',
        fontFamily: "Open Sans, sans-serif",
        marginBottom: '2vh'
    },
    blogPicContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '2%',
        display: 'flex',
        flexDirection: 'column',
        color: '#5a2a20',
    },
    postPic:{
        [theme.breakpoints.down('sm')]: {
            width: '50%',
            marginBottom: '3vh',
            marginTop: '2vh'
        },
        [theme.breakpoints.down('sm')]: {
            width: '50%',
            marginBottom: '3vh',
            marginTop: '2vh'
        },
        float: 'right',

        width: '40%',
        marginLeft: '2vw',
        marginBottom: '1vh'
    },
    postBio: {
        fontStyle: 'italic'
    },
    postLead: {
        fontStyle: 'italic',
        color: '#b68f72',
        marginBottom: '4vw',
    },
    divider: {
        borderBottom: '5px solid white',
        marginBottom: '2vw'
    }

}))

const Blog = ({ crossroads, setCrossroads }) => {

    useEffect(() => {
        setCrossroads(false)
    }, [])

    const classes = useStyles()


    return (
        <>
            <div className={classes.body}>
            <Helmet>
                <title>BLOG</title>
                <meta
                    name="description"
                    content="Read Blog Articles related to Remembering The Future"
                />
            </Helmet>
                <div className={classes.titleContainer}>
                    BLOG
                </div>
                <div className={classes.blogHolder}>

                    <div className={classes.post}>
                        <div className={classes.title}>
                           Where Stories Begin: The Imaginary, Possibility and Remembering the Future
                        </div>
                        <div className={classes.authorandDate}>
                            <div className={classes.author}> By Regina Asinde</div>
                        </div>
                        <div className={classes.blog}>

                                <br></br>
                                <span className={classes.postLead}>Telling a story can teach the story-teller as much as those who are being told. When Remembering the Future writer Regina Asinde set out to write her searing story, "Dance of Death," she had no idea how much the experience would lead her to learn much about herself, her culture and the complex interplay between the two.</span>
                                <br></br>
                                <br></br>
                                There was something fascinating about the theme of this year&#39;s Kampala Writes LitFest: “Where
                                Stories Begin: The Imaginary and the Art of Possibility.” I found it particularly compelling
                                because, as a writer, my stories can begin almost anywhere.
                                <br></br>
                                <br></br>
                                During the keynote dialogue, Chika Unigwe mentioned that one of her favourite places to pick
                                up stories is the airport. Being an avid eavesdropper, she finds herself listening to conversations
                                and stumbling upon what she described as awesome stories.
                                <br></br>
                                <br></br>
                                That made me think about my own favourite place to pick up stories: funerals. I always tell
                                people that funerals are among my favourite social events, not because I am a sadist who enjoys
                                being around bereaved people, but because funerals are a treasure trove of stories. There is
                                something about death that makes people suddenly vulnerable to their own mortality and,
                                somehow, loose-tongued. There is always a good story being told, not only about the deceased
                                but about everyone and everything in the community. Nothing seems to be taboo, especially if
                                you happen to sit next to old, wizened women preparing food, doing chores or simply sitting in
                                the room where the deceased lies in state. Everyone who walks into that room becomes a subject
                                of discussion. A new mourner walks in, offers their condolences and lets out the obligatory wail.
                                The moment they turn their back to leave, someone will say:
                                <br></br>
                                <br></br>
                                “That is so-and-so&#39;s wife, daughter, son, husband, relative…”
                                <br></br>
                                <br></br>
                                “Which one?”
                                <br></br>
                                <br></br>
                                “The one from … who…”
                                <br></br>
                                <br></br>
                                And off we go. Another story begins.
                                <br></br>
                                <br></br>
                                But my stories do not only come from funerals. They come from chronic eavesdropping, from
                                observing, from community work, from conversations and encounters. An innocent remark can
                                set something off. So can a shout from across a compound, a gesture, a photograph, a memory,
                                an object or simply something I witness and cannot quite shake off. In that sense, I found Chika&#39;s
                                observation about the airport particularly resonant. We may have different favourite hunting
                                grounds, but perhaps what we share as writers is the instinct to recognise that a story can be
                                hiding almost anywhere. Sometimes I am not even sure what I am looking for until something
                                catches my attention. Sometimes the thing that catches my attention is not the story itself but the
                                possibility of another story beneath it. I may witness something and find myself wondering:
                                What if this was told from another person&#39;s perspective? What if what appears to have happened
                                is not the whole story? What if the truth that I can see is only one version of a much larger
                                reality?
                                <br></br>
                                <br></br>
                                That, for me, is where the imaginary enters creative nonfiction.
                                <br></br>
                                <br></br>
                                As Chika Unigwe mentioned during the keynote dialogue, a story can begin with anything. For
                                me, it could be a memory, a conversation I have overheard, an object, a picture, a word; anything
                                can trigger my writing instinct and set me off on the journey of turning an experience or an idea
                                into a story.
                                <br></br>
                                <br></br>
                                Many times, my stories hold both the truth that inspired them and a full dose of the imaginary:
                                imagined people, imagined incidents and imagined possibilities. Sometimes I find myself asking,
                                What if what I witnessed was told from a different perspective? What if the story looked
                                completely different from another person&#39;s point of view?
                                <br></br>
                                <br></br>
                                That, for me, is part of the fascinating territory occupied by creative nonfiction. The story may
                                begin in lived reality, but the writer&#39;s imagination allows that reality to be interrogated,
                                reconstructed and understood in ways that may not have been immediately apparent.
                                <br></br>
                                <br></br>
                                My contribution to Remembering the Future, an anthology of creative nonfiction stories and
                                essays about Ugandan culture in a changing world, the anthology edited by Christopher
                                Conte and Hilda Twongyeirwe, is perhaps a good example of this. The anthology brings together
                                writers reflecting on Uganda&#39;s cultural traditions and what happens to them as the country moves
                                through modernity, globalisation, Christianity and other forces of change.
                                <br></br>
                                <br></br>
                                My contribution, Dance of Death, concerns the Jopadhola funeral dance and the spiritual journey
                                that grew out of my attempt to understand it. It is about my personal spiritual journey towards
                                finding freedom in faith. It is a lived account of my spiritual odyssey. In that sense, I would not
                                necessarily call it a “story”; it is more accurately a narration of lived reality.
                                <br></br>
                                <br></br>
                                But what is interesting is that I did not set out to write about my spiritual journey when I was
                                first approached by the editor of the anthology.
                                <br></br>
                                <br></br>
                                I was invited to write about an aspect of Jopadhola culture that had fascinated me as a child and
                                that I felt was slowly dying out. I wanted to document it, to preserve it in some form before it
                                disappeared. That tradition was the fumbo dance, or, more precisely, the funeral dance. Perhaps
                                this is where my favourite place for finding stories becomes significant. I had spent years
                                watching funerals, listening to the stories that emerged from them, observing the rituals, the
                                mourners, the old women, the music and the strange mixture of grief, memory, gossip, laughter
                                and spirituality that can coexist around death.
                                <br></br>
                                <br></br>
                                Growing up at the crossroads of being a Christian and a young girl nurtured and groomed within
                                Jopadhola traditions, I found fumbo deeply intriguing. I had always been fascinated by the idea
                                of death. At the same time, I harboured a deep-seated fear of death in whatever form it appeared.
                                <br></br>
                                <br></br>
                                And yet, among the Jopadhola, during what could arguably be the darkest and most painful
                                moment in a family&#39;s life—the hour of finality—loved ones were expected to dance and dirge
                                through the dark, cold night and into the early hours of the morning before the deceased was
                                finally laid to rest.
                                <br></br>
                                <br></br>
                                I often wondered what that meant.
                                <br></br>
                                <br></br>
                                At one point, I thought perhaps it was a kind of mockery of death, an almost defiant response to
                                something that frightened us. It reminded me of the Christian proclamation in 1 Corinthians
                                15:55: “O death, where is thy sting? O grave, where is thy victory?” There seemed to be
                                something about dancing in the face of death that could be interpreted as refusing to give death
                                the final word.
                                <br></br>
                                <br></br>
                                At other times, I saw it differently.
                                <br></br>
                                <br></br>
                                Perhaps it was simply a final farewell, a way of celebrating a life that had been lived even in the
                                midst of the pain of losing someone. Perhaps it was a way of keeping company with the dead one
                                last time. Or perhaps it was a way of connecting with loved ones who had gone ahead.
                                <br></br>
                                <br></br>
                                I carried all these questions with me. There was also another layer to my fascination. As a
                                recently converted Born Again Christian at that time, I wanted to deconstruct some of the
                                spiritual rituals that seemed to have such a strong hold on culture and tradition. I wanted to
                                understand them beyond the surface: What did they mean? Where did they come from? And
                                ultimately, how did they shape or affect a person&#39;s spiritual life?
                                <br></br>
                                <br></br>
                                This was where my long conversations with Conte became important.
                                <br></br>
                                <br></br>
                                We talked extensively about the spirituality of African people and about the fact that the entire
                                embodiment of an African can be understood as spiritual. There is often no neat separation
                                between the sacred and the secular in the African way of life. From conception to death, from the
                                ordinary and mundane tasks of living in rural Africa to extraordinary supernatural encounters,
                                there is often a spiritual meaning attached to life.
                                <br></br>
                                <br></br>
                                Among the Jopadhola, there is a saying that there is no death without a witch. Even when a death
                                appears to have an obvious explanation, there can still be a search for a supernatural cause.
                                Someone may have been bewitched; someone may have caused the death; something beyond the
                                visible world may be considered responsible.
                                <br></br>
                                <br></br>
                                We talked about how Jopadhola funeral rituals differed from those of other Ugandan
                                communities, but also about how similar we all are in the ways we mourn our loved ones. Every
                                community has its own funeral rites, rituals and ways of saying goodbye, yet beneath those
                                differences is the universal human experience of grief and loss. And the unshakeable belief that
                                the death was mere transition to another world, the realm of the tipu, or should I say, spirits.
                                <br></br>
                                <br></br>
                                We also talked about how some of these rituals and traditions are dying out, while those that
                                remain are sometimes only shallow imitations of the originals. Christianity was one of the
                                biggest influences in phasing out or pushing aside some of these traditions, alongside Western
                                influence, civilisation and modernity. The changing world was altering not only how people
                                lived but also how they understood and practised the traditions inherited from previous
                                generations.
                                <br></br>
                                <br></br>
                                We eventually agreed that I would interview a fumbo artist and document the story of this
                                tradition.
                                <br></br>
                                <br></br>
                                So I went into the field. I spoke to a fumbo artist and captured his story. What I came back with
                                did not seem to be the story that was ready to be told. Something was missing.
                                <br></br>
                                <br></br>
                                We returned to our lengthy conversations, trying to identify the missing plot lines, the things that
                                were underneath the story I had collected. Eventually, I was told to tell my own personal story,
                                the story that could depict more clearly just how much these changing dynamics had affected
                                traditional culture and, more importantly, how they had affected me.
                                <br></br>
                                <br></br>
                                That is how the story became something else entirely. What had begun as an attempt to
                                document fumbo became an exploration of my own spiritual journey. The funeral dance became
                                a doorway into questions about death, spirituality, culture, Christianity, fear and freedom.
                                <br></br>
                                <br></br>
                                Perhaps this is where Remembering the Future and the Kampala Writes LitFest theme
                                unexpectedly meet.
                                <br></br>
                                <br></br>
                                A story does not always end where it begins. Sometimes, we begin by trying to document
                                someone else&#39;s experience and discover that the real story is buried within our own. Sometimes
                                we begin with a cultural practice and end up confronting our own identity. Sometimes we begin
                                with memory and arrive at possibility.
                                <br></br>
                                <br></br>
                                For me, archiving the fumbo practice was the beginning. It was the key that opened a door into
                                questions I had carried for years—questions about what I had inherited, what I believed, what I
                                feared and what I was beginning to understand differently. And this is what I found so
                                fascinating about the idea of “Where Stories Begin.” Stories do not necessarily begin with the
                                intention of writing them. Sometimes, they are already living inside us. An experience sits
                                somewhere in memory. A conversation stays with us. An object evokes something we thought
                                we had forgotten. A cultural practice raises a question. A contradiction refuses to settle. Then
                                something happens and the imagination takes over. Not necessarily by inventing a different
                                reality, but by allowing us to look again at the reality we have lived.
                                <br></br>
                                <br></br>
                                That is perhaps one of the great possibilities of creative nonfiction: it gives us room to return to
                                lived experience and ask what else might be contained within it. My journey with Remembering
                                the Future began with a disappearing cultural tradition. But the story I eventually wrote was
                                about what happens when inherited culture encounters Christianity, modernity and personal
                                transformation. It became a story about negotiating inheritance: What do we keep? What do we
                                question? What do we reject? What do we reinterpret? And what happens when the beliefs and
                                traditions that shaped us encounter a faith that asks us to see the world differently?
                                <br></br>
                                <br></br>
                                These are not easy questions, particularly because culture is not something that exists outside us.
                                It lives in us. It shapes our fears, our assumptions, our understanding of life and death, and
                                sometimes even our understanding of God.
                                <br></br>
                                <br></br>
                                That is why I think the theme of the festival speaks so powerfully to the anthology.
                                <br></br>
                                <br></br>
                                Remembering the Future is, in many ways, an attempt to look backwards while thinking
                                forwards. To remember what is disappearing, not merely for nostalgia&#39;s sake, but because what
                                we remember can help us interrogate the present and imagine what might be possible in the future. And perhaps that is what storytelling does at its best. It does not simply preserve what has
                                been. It allows us to examine it. It allows us to ask questions of it. It allows us to imagine what
                                could be different.
                                <br></br>
                                <br></br>
                                My story began with fumbo but it did not remain a story about fumbo. It became a story about
                                what happens to culture when the world around it changes and what happens to us when we are
                                caught in that change. It became a story about the tension between what we inherit and what we
                                choose. It became a story about faith and freedom. Perhaps that is the real art of possibility: not
                                simply imagining worlds that have never existed, but finding the courage to look again at the
                                world we inherited and ask what else it might become.
                                <br></br>
                                <br></br>
                                That, ultimately, is where my stories begin. Anywhere. A funeral. A wedding. A day at the local
                                hair salon. A memory. A conversation. A photograph. An object. A word. A cultural practice. A
                                question. Sometimes, as with fumbo, what appears to be the beginning turns out to be only the
                                doorway to the story that was waiting underneath.
                                <br></br>
                                <br></br>

                            </div>
                    </div>

                    <div className={classes.divider}>

                    </div>

                    <div className={classes.post}>
                        <div className={classes.title}>
                            Remembering the Future Joins the Canon of “African Cultural Resistance Literature”
                        </div>
                        <div className={classes.authorandDate}>
                            <div className={classes.author}>By Philip Matogo </div>
                        </div>
                        <div className={classes.blog}>

                                <img className={classes.postPic} src={fasihi}></img>
                                On July 4, copies of the groundbreaking book “Remembering the Future: Reflections on
                                Ugandan Culture in Changing Times”, were donated to the Community Libraries
                                Association of Uganda (COLAU/UgCLA), the leading network for grassroots and
                                community-run libraries across the country at the Kawempe Youth Center.
                                <br></br>
                                <br></br>
                                The event, basking in the soft-glow of a Kampala morning, was attended by a number of
                                Ugandan stakeholders in promoting reading cultures and digital literacy.
                                <br></br>
                                <br></br>
                                To set the event in train, Ms. Edna Namara discussed her work. In her essay from the
                                anthology Remembering the Future: Reflections on Ugandan Culture in Changing
                                Times. In her story, A Bride’s Farewell Song, Ms Namara shares a personal and
                                reflective story about her upbringing in southwestern Uganda. She navigates the
                                complex tension between traditional African values and the rapid, often overwhelming
                                changes brought on by globalization and modernization.
                                <br></br>
                                <br></br>
                                By recounting her own life, Namara explores the friction between the indigenous
                                knowledge and cultural morals taught to her by earlier generations, and the modern,
                                Western-influenced aspirations of today’s youth. Her narrative emphasizes how
                                language and storytelling act as crucial bridges between generations. She highlights the
                                importance of keeping ancestral wisdom alive to ground the contemporary Ugandan
                                identity amid societal shifts.
                                <br></br>
                                <br></br>
                                Her story, set in southwestern Uganda, challenges cultural practices of the Bakiga tribe
                                which stand in stark contrast lessons gleaned from woman emancipation and
                                empowerment between the sexes. It touched off a quiet storm of discussion as
                                attendees were forced to look their own cultural inclinations in the eye as they
                                questioned themselves forthrightly.
                                <br></br>
                                <br></br>
                                The book Remembering the Future is sure to have an even greater impact on Ugandan
                                society, adding to its already salutary impact.
                                <br></br>
                                <br></br>
                                “Partnering with Remembering the Future is an opportunity for Community Libraries
                                Association to first of all share the stories written in the book with other community
                                libraries, not just in Kawempe. Because we currently have over a 100 community
                                libraries. So much as we had a representation from few of the libraries, as an
                                association we are going to come up with short posts and ignite conversation around
                                the stories in the book. The stories shared directly resonate with our societies. The
                                stories are real life stories and these are things that happen in our societies. It’s an
                                opportunity for our members to also have these conversations in their library spaces
                                and discuss the realities of things in line with those stories,” says Catherine Amia
                                Walsh, the National Coordinator for the Community Libraries Association of Uganda
                                (COLAU), an umbrella NGO and network of over 150 community libraries dedicated to
                                promoting productive literacy practices and achieving “a library in every village”.
                                <br></br>
                                <br></br>
                                The anthology Remembering the Future: Reflections on Ugandan Culture in Changing
                                Times is a cultural milestone on the road to barrier-breaking and thought-fomenting
                                literature. This anthology was published in 2023 by  Ibua Publishing . Christopher Conte,
                                an American journalist who spent fifteen years as a reporter and editor for the Wall
                                Street Journal before beginning a freelance career, co-edited the anthology to
                                meaningful notoriety.
                                <br></br>
                                <br></br>
                                Adding icing to a CV that even Mr. Conte’s naysayers would say yes to, Ugandan
                                author/book editor Ms. Hilda Twongyeirwe throws more than her bluestockings into
                                the arena, so to speak. Her efforts to support the growth of literature in Uganda
                                and beyond cannot be gainsaid.
                                <br></br>
                                <br></br>
                                Muscling in alongside a star-spangled cast of Ugandan writers, the editorial duet’s
                                efforts to light up Uganda’s literary firmament are an unqualified success.
                                <br></br>
                                <br></br>
                                “I am hnoured by the interest and support you have shown for Remembering the Future.
                                I can’t think of an audience to reach for our book, which celebrates your rich heritage
                                and raises important questions about its future,” says Mr. Conte.
                                <br></br>
                                <br></br>
                                This highly acclaimed book challenges Eurocentric narratives that label African
                                traditions as barriers to modern development. Famous Ugandan poet and educator
                                Timothy Wangusa hailed it as “the most outstanding book that Uganda has yet
                                mothered.”
                                <br></br>
                                <br></br>
                                To be sure, Professor Wangusa’s clever turn of phrase is also his nod to cultural
                                resistance in literature. Cultural resistance is the practice of using creative
                                expressions—such as language, symbols, music, art, and traditions—to contest a
                                dominant power or preserve an identity under threat.
                                <br></br>
                                <br></br>
                                Cultural resistance in African literature is the deliberate use of creative writing to
                                challenge colonial hegemony, dismantle Eurocentric stereotypes, and reclaim
                                indigenous history and identity. Rather than relying solely on political or military warfare,
                                African writers weaponize storytelling to subvert the psychological and cultural impacts
                                of imperialism.
                                <br></br>
                                <br></br>
                                Well known literati in African literature who employed this literary approach were Chinua
                                Achebe (Nigeria), widely regarded as the father of modern African literature. He
                                countered colonial texts by depicting complex, self-governing pre-colonial Igbo societies
                                in his masterpiece trilogy (Things Fall Apart, No Longer at Ease, Arrow of God).
                                <br></br>
                                <br></br>
                                Another quiver from that Arrow of God was Ngũgĩ wa Thiong’o (Kenya). He remains the
                                leading voice on linguistic decolonization. He famously abandoned writing in English to
                                write exclusively in Gikuyu, arguing that utilizing a colonizer’s language traps the African
                                mind in an ongoing state of cultural captivity.
                                <br></br>
                                <br></br>
                                For a literary trifecta, Wole Soyinka (Nigeria) must be noted as a chief exponent of
                                cultural resistance. The first African Nobel Laureate in Literature. He synthesized
                                traditional Yoruba cosmology, mythology, and ritual drama with Western theatrical forms
                                to build a powerful aesthetic framework that fiercely criticized both colonial rule and
                                post-independence local dictatorships. The book Remembering the Future: Reflections
                                on Ugandan Culture in Changing Times joins the literary canon.
                                <br></br>
                                <br></br>
                                <span className={classes.postBio}>
                                Philip Matogo is an editor at Fasihi
                                Magazine, an online literary
                                publication in Kampala, Uganda. For
                                more pictures and full text of his
                                speech, visit the magazine at
                                <a className={classes.link} href='https://fasihimag.com/remembering-the-future-reflections-on-ugandan-culture-in-changing-times/'> https://fasihimag.com/remembering-the-future-reflections-on-ugandan-culture-in-changing-times/</a>
                                </span>

                            </div>
                    </div>

                    <div className={classes.divider}>

                    </div>

                    <div className={classes.post}>
                        <div className={classes.title}>
                            The Things People Discuss
                        </div>
                        <div className={classes.authorandDate}>
                            <div className={classes.author}>By Rosey Sembatya </div>
                        </div>
                        <div className={classes.blog}>

                                <img className={classes.postPic} src={rosey2}></img>
                                If you have never been around writers, let me tell you what writers talk about when
                                they meet. Hold on: This may make you dizzy.
                                <br></br>
                                <br></br>
                                I recently was privileged to meet members of the Growth
                                Lane book club in Entebbe. It was their end-of-the-month
                                meeting, and they were featuring Remembering the
                                Future, a collection of essays that I have been proudly
                                promoting.  The club hosted one of the book’s 12 writers,
                                Mr. Joachim Buwembo, a seasoned journalist and writer
                                and now the chairman of the Uganda Printing and
                                Publishing Corporation, which publishes the Uganda
                                Gazette.
                                <br></br>
                                <br></br>
                                The conversation started before the meeting officially
                                began, gliding through so many topics I had trouble keeping up. It was exciting,
                                though. Like life itself, the conversation was made up of intertwined elements.
                                Even before the MC called us to order, there was talk of Namakula’s place in
                                Kitara, a venue where intense, structured conversations are held on complicated
                                topics. I wondered how the conversation could ever get to the book we were there
                                to discuss and its brain teasing title? I wasn’t sure how we could leap to that
                                question. Would we end up stealing the future we had planned for the day?
                                <br></br>
                                <br></br>
                                Stealing the future seems as nonsensical as remembering it; how can you steal or
                                remember something that doesn’t yet exist? But then the book’s invitation to
                                remember took me back to 1998. If you are Ugandan, that year should be
                                important to you because it was when the decision was made that land would
                                belong to anyone who had occupied it for at least 12 years. From thoughts of 1998,
                                the mind readily jumps further back to 1986, when the NRA captured power and
                                set the 12-year occupancy requirement for land ownership. Even today, if you have
                                been on the land for 40 years and are claiming ownership, your mind is drawn back
                                to 1986, 1998 – and to current times, the “future” that was shaped four decades
                                ago.
                                <br></br>
                                <br></br>
                                As I pondered time, the book club’s conversation somehow moved on to our dear
                                prime minister, who is about to get her PhD without stepping into a lecture room. It
                                jumped to observations that there are fewer mountain gorillas in Rwanda than the
                                Rwandans perceive, and from there members talked about how Arsenal players
                                must visit Rwanda every year for two weeks and tweet about it. Is that a
                                governance issue, a strategic issue, or is it just a matter of love for one’s country?
                                <br></br>
                                <br></br>
                                I think it boils down to love for one’s country. A bigger, fancier term for it is
                                democracy. Suddenly, I saw the connection between these random bits of
                                conversation. Disciplined discussion. Policy. Ethics. The environment in which we
                                live. The various strands of conversation all arose from the effort to understand
                                who we are and, by implication, who we want to become. When the MC called our
                                meeting to order, our guest noted that the Kabaka, by tradition takes on the clan of
                                his mother. Why? So that no clan gets monopoly over becoming Kabaka. All the
                                52 clans know that one day they will get a Kabaka from their clan. Surely, that is
                                democracy in action.
                                <br></br>
                                <br></br>
                                Clans are modelled around animals, and all clan headquarters are on hills and
                                forests, an arrangement that ensures that the clans serve as our environment
                                bodyguards – a vital link, Mr. Buwembo noted, between our past and future.
                                <br></br>
                                <br></br>
                                The conversation moved to how Buganda’s clan system grew from the original five to 52 clans. Most clans came with the Kabakas, who conquered and added them to
                                Buganda. Then the conversation moved to Luganda orthography. Did you know
                                that the largest clan, the Mamba clan (lung fish), is originally from Kenya/Luo?
                                Take the name Mubiru, a common name among the Mamba clan. It was originally
                                Ombiro. But the Luganda orthography doesn’t have O to start any name. So the
                                Baganda decided to delete the O and start with M and add the vowel u to make
                                Mubiru. This was particularly interesting because my daughter’s name is
                                Namubiru. She carries with her a vital piece of our heritage.
                                <br></br>
                                <br></br>
                                The night was closing in. Somehow the discussion moved from our speaker’s
                                experience in Tanzania where he went to write for Kilimo Trust. Much of his work
                                there was about promoting agriculture.  He regaled us with tales of the coast. When
                                the water levels rise by even a centimeter, the soil in the nearby places will get
                                salty. There is no coast talk without Djinn forces. These are powerful forces to
                                which mermaids belong. They can give wealth. Mzee Buwembo witnessed a Djinn
                                exchanging experiences that left him in awe. A people’s heritage lives on in a
                                modern nation.
                                <br></br>
                                <br></br>
                                When book people meet, their conversations may seem unstructured but they can
                                be full of insight. They range from the past to the present, but they are driven by a
                                concern for the future. Our discussants in Entebbe that day spent a lot of time
                                remembering, but they were remembering for a purpose. They were remembering a
                                new future into being.
                                <br></br>
                                <br></br>
                                <span className={classes.postBio}>
                                    Rosey Sembatya is a writer and education consultant. She contributed chapter to
                                    the book “Crossroads: Women Coming of Age in Today’s Uganda” and is an
                                    enthusiastic promotor of Remembering the Future.”
                                </span>

                            </div>
                    </div>

                    <div className={classes.divider}>

                    </div>

                    <div className={classes.post}>
                        <div className={classes.title}>
                            Under Attack
                        </div>
                        <div className={classes.authorandDate}>
                            <div className={classes.author}>By Ophelia Kemigisha </div>
                        </div>
                        <div className={classes.blog}>

                                <img className={classes.postPic} src={ophelia}></img>
                                When I was 13 years old, my brother slapped me hard across the face. I was washing dishes
                                in the kitchen, which used to be a hangout spot for everybody. Like many Ugandan
                                households, it was home to a diverse collection of people. I lived with my three sisters, and
                                cousins and other relatives stayed with us at different times. My half-brother was a late-
                                comer, having arrived in our family after spending most of his early years with his mother.
                                When he hit me, I remember bursting into tears and leaving the kitchen, too startled to hit
                                him back. I cannot recall what the spat was about, and we now share a close friendship.
                                <br></br>
                                <br></br>
                                My sisters and I often fought when we were growing up – for the TV remote, to ride
                                shotgun, and even for sport. After slapping me, he was spanked for a crime we’d been
                                getting away with – apparently, he was not allowed the privilege of sibling rivalry. What
                                stuck with me was the reason for his punishment: During the firm disciplining, my father
                                asked him repeatedly what he had been doing in the kitchen in the first place.
                                <br></br>
                                <br></br>
                                Growing up in a predominantly female household and then attending an all-girls boarding
                                secondary school, did not prepare me for “real life.” For a long time, the distinction society
                                makes between men and women was not obvious to me. I had seen girls play football, excel
                                in class, and take up leadership positions.
                                <br></br>
                                <br></br>
                                I grew up in the late 1990’s and early 2000s, when mainstream media were filled with
                                stories of empowered women. The tough-as-nails Justice Julia Sebutinde, who was recently
                                appointed to the International Court of Justice, was leading a highly publicised probe into
                                corruption scandals, which led to various changes in public offices in Uganda. She was
                                described as the petite fiery judge. It was said she could make grown men shake in their
                                trousers. She made many shed tears. We also had the first female vice president in Africa,
                                Dr Specioza Wandira Kazibwe, for nine years. We had this female Member of Parliament,
                                Hon Miria Matembe, who proposed that rapists be castrated. It raised hell in Uganda’s
                                public! Many other women were starting to rise to the top in different spheres.
                                <br></br>
                                <br></br>
                                Still, I was hoodwinked to believe that men were superior. Men were the “heads of the
                                family,” the billionaires, the “natural” leaders. This story is sold in mainstream media, in
                                movies and soaps, in church, even in the school’s curriculum. We still were told that men
                                had certain roles and women had others. Men provided for their families and worked;
                                women cooked and cleaned. Women could study and work, but were often reminded that
                                they were not men, so they had to go home and be women. It was common to praise
                                women for how much work they did for their husbands and children, but to give them no
                                recognition for what they did outside the home.
                                <br></br>
                                <br></br>
                                Society has evolved in many different ways since. The average Ugandan has gone through
                                some formal education, owns a mobile phone, watches television, and probably has a
                                theory about why Donald Trump was elected. People are willing to embrace change in many
                                areas of their life: they can get new phones, change their style of dressing, even try out a
                                new beer. Women, especially the single ones, are among the big land owners in and around
                                Kampala. But the ration is still low.
                                <br></br>
                                <br></br>
                                But Ugandans still refer to women with a nostalgic shake of their heads and the word
                                “nowadays.” “You know women of nowadays: they want to be men,” the saying goes.
                                <br></br>
                                <br></br>
                                Yet in reality, many women “nowadays” are fighting back against the “culture” – especially
                                when they realise that they have been given the short end of the stick. In many Ugandan
                                communities, women are pushed to the margins under the pretext they have to observe
                                traditional gender roles. One of the areas that remains heavily influenced by culture is
                                weddings and marriage. Even amongst “middle class” Ugandans, there is a strong
                                attachment to cultural rites surrounding weddings. During bridal showers, for instance,
                                ssengas dispense marriage and sex advice centred on pleasing the man (this function used
                                to be served by paternal aunts of the bride, but the role has today been turned round for
                                economic value and is done by hired professionals. Among my people, the Banyankore, it is
                                men from the potential groom and potential bride’s family who are almost exclusively
                                involved in negotiating enjugano, loosely translated as “bride price”. This haggling over the
                                value of brides as if they were cows in the market has become especially odd in this age
                                where money takes precedence over all. This is compounded by the absence of women in
                                the process, so that it all strikes me as deeply patriarchal.
                                <br></br>
                                <br></br>
                                Today, women are increasingly sharing space with men in ways that the society previously
                                did not allow; they can be business partners, work colleagues, friends and “friends with
                                benefits.” Yet as the famous religious instruction by St. Paul who required women to submit
                                only to their husbands is quoted and emphasised at every wedding, men in all these spaces
                                expect this submission. Many Ugandan men are very comfortable living by a double
                                standard. Yes, a woman must work outside the home and contribute, but she must also
                                carry out the bulk of house work – and care for the children and older relatives. We are told
                                we must raise girls to be assertive, but they must also obey and “respect” men because men
                                are still in charge.
                                <br></br>
                                <br></br>
                                In urban centres, some women are now at the helm of organisations, literally signing men’s
                                pay cheques. This shows that women are just as able as men. When the boys beat you in
                                class today and you beat them tomorrow, you get better performance reviews at work
                                today and they get better reviews following day, then you start to think: Maybe men are not
                                special after all.” It then becomes difficult to watch your husband watch TV as you break
                                your back with household chores and care-work when you cross the threshold after
                                knowing you can outsmart men just the same way they can outsmart women.
                                <br></br>
                                <br></br>
                                Despite the ostensible advances women have made, many men – and women – still have a
                                hard time getting accustomed to women occupying spaces outside of the home. The notion
                                of having a female president is laughable to most, even though Speciosa Wandira Kazibwe
                                once served as Vice President. Some members of the elites grumble that affirmative action
                                is “going too far” and is putting boys and men at a disadvantage. In 1990, the government
                                decided to give an extra 1.5 points in admission scores to all female students joining public
                                universities, and the number of female graduates started to increase. At Makerere, the

                                nation’s largest university, the share of females graduated surpassed males for the first time
                                in 2010 and reached around 55% overall in some years after that. But the female rate
                                dropped to a meagre 0.6 percentage points in 2019. Meanwhile, in Parliament, female
                                representation is below 35%, even when seats are set aside for women in every
                                constituency. This, apparently, is Uganda’s definition of going too far.
                                <br></br>
                                <br></br>
                                Moreover, the crop of empowered women makes up only a small, privileged group. The
                                majority is poorer women who have access to resources only via male relatives or husbands
                                and continue to suffer. Burdened with unpaid care work like having almost the sole
                                responsibility for raising children and taking care of the elderly and the sick, they still work
                                on land they do not own. Sometimes they do not even have ownership of what they grow
                                on this land. They also continue to suffer domestic violence at disproportionate rates.
                                Unfortunately, the success of a few visible women, especially those in positions of authority
                                has not translated to gender equality all over the country.
                                <br></br>
                                <br></br>
                                A whole new world has opened up for women, though: We can go to school, occupy
                                legislative office, open businesses, own land and travel the world – all without the approval
                                of a man. It is okay for women to be found everywhere: at the helm of the city council, in a
                                bar at 3 am, in the corner office, on social media yelling “Men are trash!” and organising a
                                Women’s March.
                                <br></br>
                                <br></br>
                                On social media, interactions between men and women have become more and more
                                fraught and combative. Regardless of what a woman posts, she is likely to receive unseemly
                                comments. A cursory glance through the comments on a female celebrity’s photo posted on
                                Twitter includes an unflattering picture posted as if to discredit her beauty, jokes about her
                                having to announce her new clothes, references to her genitalia, and one lone, inexplicable
                                “B**ch.”
                                <br></br>
                                <br></br>
                                Women who identify as feminists and use the internet for activism report higher levels of
                                harassment and online abuse. Insults usually have to do with us being emotional, ugly,
                                unlovable, and unlikely to find men to marry because we are ugly and unlovable.
                                Sometimes, the attacks seem organised, with trolls swarming online like bees. They go
                                beyond insults; trolls sometimes dish out rape and murder threats. A close friend who
                                started posting openly feminist posts on her Facebook page received numerous comments
                                that she is sex- deprived and wishes to be sexually assaulted. A number of men started
                                commenting on her posts, exchanging jokes about this possibility; one of them bizarrely,
                                targeting her nose. Trolls might be easy to dismiss when they are reported in the news as
                                manufactured in a lab to influence various elections, but it is not that simple when they are
                                friends of friends, men who are known to someone you know, who could very easily find
                                you if they tried.
                                <br></br>
                                <br></br>
                                In pop culture, it is perfectly acceptable for men to sing songs that claim women as
                                “property” and for adverts to portray street harassment presented as if it were a normal
                                way for a man to approach a woman. If a woman points out that such stereotypes are
                                harmful to women, she is accused of taking everything too seriously. Yet, this sense of
                                entitlement to the bodies of women really is harmful. I learnt how to walk further away
                                from men in downtown Kampala when I was still a teenager. My friends and I are constantly
                                afraid, or at least wary, that a man may interrupt a good day with a form of violence, from
                                catcalling or groping, to physical or sexual assault.
                                <br></br>
                                <br></br>
                                On the other hand, men mostly express annoyance at being rejected by women, whether
                                that takes the form of refusing a hug or blocking them on social media. Of course, many
                                men in Uganda face some form of oppression depending on their class, sexual orientation or
                                ethnic origin. This, however, does not necessarily translate into an empathetic view of how
                                women navigate a male-dominated world and a commitment to refrain from harming the
                                women they encounter.
                                <br></br>
                                <br></br>
                                In my interactions with men, some of them have expressed dissatisfaction with the place
                                society assigns them. Yet, they are unwilling to go against the grain and give up the power
                                that comes with the societal pressure to be “man enough”. We have all received and
                                absorbed the same messages about masculinity and femininity. Unlearning these narratives
                                can be a painful process, and less attractive to those who mostly benefit from keeping
                                things as they are.
                                <br></br>
                                <br></br>
                                I am an endless optimist. Despite all the problems I see, and how dysfunctional relationships
                                between men and women often seem, I like to think that more and more people are
                                reimagining life outside of the known social script. That means that we can create a new
                                society where men and women can achieve their full potential. Society can relieve men of
                                the burden to dominate and women of the burden to submit, regardless, and allow them to
                                exercise their full humanity. Society can allow women to enjoy full bodily autonomy and
                                agency and live more fulfilling lives. People often say women and men misunderstand each
                                other, but I think dismantling systems that oppress one group will clear up those
                                communication channels.
                                <br></br>
                                <br></br>
                                I know my brother will never hit a woman because he was taught that lesson at an
                                impressionable age with my father’s red slipper. Even better, I know that as we come to see
                                so many women defining themselves without reference to gender roles, he can fathom
                                women as full human beings outside of their “roles” at home. And today, my brother is not
                                afraid to go to the kitchen: That is the progress that will create a better and free society for
                                women and men.
                                <br></br>
                                <br></br>
                                <span className={classes.postBio}>
                                    Ophelia Kemigisha is a feminist activist, human rights lawyer, and writer. She is interested in
                                    infusing radical politics into legal structures in order to fight patriarchal violence and
                                    oppression. She lives in Kampala, Uganda where she reads, dances, and tweets for the
                                    revolution.
                                    <br></br>
                                    <br></br>
                                    “Remembering the Future” has several chapters that address gender relations and roles.
                                    Edna Namara’s “The Bride’s Farewell Song” describes the recollections of a grandmother on
                                    weddings and marriages in the hill country of Rukiga in Western Uganda. Linda Orando’s
                                    “Goria Ubuntu” shares the reflections of her grandfather, a family patriarch, on family and
                                    the roles of men and women in the family’s compound in Asinge in Eastern Uganda. And
                                    Wobusobozi Amooti Kangere shatters stereotypes in “A Tale of Two Matriarchs,” the story of
                                    powerful matriarchs who led his family and community western Uganda’s Ibanda district.

                                </span>
                            </div>
                    </div>
                    

                </div>

            </div>
        </>
    );


}

export default Blog;

